import { useI18n } from "i18n";
import { ChangeEvent } from "react";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { ForgetPasswordForm } from "modules/auth/forgetPassword/ForgetPasswordForm";
import { useStyles } from "./ForgetPassword.styles";

interface IForgetPasswordProps {
  eventCode?: string;
  emailInput: string;
  setEmailInput: (e: string) => void;
}

const ForgetPassword = ({
  eventCode,
  emailInput,
  setEmailInput,
}: IForgetPasswordProps) => {
  const { t } = useI18n(["eventLanding"]);
  const styles = useStyles();

  const handleEmailChange = (e: ChangeEvent<HTMLInputElement>) => {
    setEmailInput(e.target.value);
  };

  const continueURL = eventCode
    ? `${window.location.protocol}//${window.location.host}/e/${eventCode}/register`
    : undefined;

  return (
    <div>
      <Typography variant="body1" className={styles.description}>
        {t("eventLanding:reset.password.title")}
      </Typography>
      <div>
        <ForgetPasswordForm
          email={emailInput}
          onChange={handleEmailChange}
          continueURL={continueURL}
        />
      </div>
    </div>
  );
};

export default ForgetPassword;
